import Shell from "../../../layouts/LoginShell.vue";
import Login from "../views/LoginJobSeeker.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Registration from "../views/Registration.vue";
import ResetPassword from "../views/ResetPassword.vue";
import SuperAdminLogin from "../views/SuperAdminLogin.vue";
import Dashboard from "../../../layouts/SeekerShell.vue";
import Tiles from "../../dashboard/views/DashboardTiles.vue";

// Define a function to conditionally import the component based on screen size
function getRegistrationComponent() {
  const isIpad = /iPad/.test(navigator.userAgent);
  if (isIpad) {
    return import("../views/RegistrationV2.vue");
  } else {
    return import("../views/Registration.vue");
  }
}

export default [
  {
    path: "/",
    name: "jobSeekerModule",
    component: Shell,
    children: [
      {
        path: "jobseeker-login/",
        name: "jobseeker-login",
        component: Login,
        title: "Login"
      },
      {
        path: "/jobseeker-register/",
        name: "jobseeker-register",
        component: Registration,
        title: "Registration"
      },
      {
        path: "/jobseeker-register/:userid",
        name: "jobseeker-register",
        component: () => getRegistrationComponent(),
        title: "Registration"
      },
      {
        path: "/forgot-password/",
        name: "forgot-password",
        component: ForgotPassword,
        title: "Forgot Password"
      },
      {
        path: "/reset-password/:token/:email",
        name: "reset-password",
        component: ResetPassword,
        title: "Reset Password"
      },
      {
        path: "/login/:userId/:jobSeekerId/:token",
        name: "login",
        component: SuperAdminLogin,
        title: "Login"
      }
    ]
  },
  {
    path: "/",
    name: "jobseekerModule",
    component: Dashboard,
    children: [
      {
        path: "jobseeker-dashboard",
        name: "jobseeker-dashboard",
        component: Tiles,
        title: "Tiles",
        meta: {
          requiredRole: "JobSeeker"
        }
      }
    ]
  }
];
